import { userUiPreferenceStorage } from "../../lib/userUiPreferenceStorage.js";
// Paramètres des onglets Geotab, conservés pour l'utilisateur jusqu'à sa prochaine modification.
export const DEFAULT_PREFERENCES = {
  radius_m: 1000, tolerance_min: 15, min_off_min: 10, dispatch_gantt: false, releve: false,
  live_filter: "all", live_show_all: false, calibration_single_visits: false, calibration_from: null, calibration_to: null, gap_min: 15,
  comparison_plan: "current",
};
export const THRESHOLD_CHOICES = {
  radius_m: [[500, "500 m"], [1000, "1 km"], [1500, "1,5 km"], [2000, "2 km"]],
  tolerance_min: [[15, "± 15 min"], [30, "± 30 min"], [45, "± 45 min"], [60, "± 1 h"]],
  min_off_min: [[5, "5 min"], [10, "10 min"], [15, "15 min"], [20, "20 min"]],
  // Écart toléré des onglets du Calibrage : colore les pastilles, sans recalcul.
  gap_min: [[5, "± 5 min"], [10, "± 10 min"], [15, "± 15 min"], [20, "± 20 min"], [30, "± 30 min"]],
};

// Une valeur retirée des choix (± 10 ou ± 20 min) reprend la valeur par défaut.
export function normalizePreferences(saved) {
  const preferences = { ...DEFAULT_PREFERENCES, ...saved };
  Object.entries(THRESHOLD_CHOICES).forEach(([key, choices]) => {
    if (!choices.some(([value]) => value === preferences[key])) preferences[key] = DEFAULT_PREFERENCES[key];
  });
  return preferences;
}

export const toleranceLabel = (minutes) => THRESHOLD_CHOICES.tolerance_min.find(([value]) => value === minutes)?.[1] ?? `± ${minutes} min`;

// Date et Jour/Soir : gardés dans l'onglet jusqu'à la déconnexion (vidés par AppRouter).
const SESSION_KEY = "grain:geotab-session";

export function readGeotabSession() {
  try {
    return JSON.parse(userUiPreferenceStorage("session").getItem(SESSION_KEY) || "{}") || {};
  } catch {
    return {};
  }
}

export function writeGeotabSession(patch) {
  try {
    userUiPreferenceStorage("session").setItem(SESSION_KEY, JSON.stringify({ ...readGeotabSession(), ...patch }));
  } catch {
    // Sans stockage, la journée reste valable jusqu'au rechargement de la page.
  }
}

export function clearGeotabSession() {
  try {
    userUiPreferenceStorage("session").removeItem(SESSION_KEY);
  } catch {
    // Rien à effacer.
  }
}
